// Owner Portal utilities

// Platform colors for calendar/reservations
const PLATFORM_COLORS = {
  airbnb2: '#FF5A5F',
  airbnb: '#FF5A5F',
  bookingCom: '#003580',
  booking: '#003580',
  'booking.com': '#003580',
  vrbo: '#3B5998',
  homeaway2: '#F5A623',
  direct: '#34C759',
  manual: '#34C759',
};

export const getPlatformColor = (platform) => {
  return PLATFORM_COLORS[platform] || '#007AFF';
};

const CURRENCY_LOCALES = {
  EUR: 'fr-FR',
  USD: 'en-US',
  GBP: 'en-GB',
  ILS: 'he-IL',
  CHF: 'de-CH',
};

// Session-wide default currency. Set ONCE from company data (admin dashboard:
// useMyCompany; owner portal: stats payload) so the ~60 existing formatAmount
// call sites that don't pass a currency all follow the company's setting —
// a US company renders $ everywhere without touching each caller.
let sessionCurrency = 'EUR';
export const setSessionCurrency = (currency) => {
  if (currency && typeof currency === 'string') sessionCurrency = currency.toUpperCase();
};
export const getSessionCurrency = () => sessionCurrency;

const CURRENCY_SYMBOLS = { EUR: '€', USD: '$', GBP: '£', ILS: '₪', CHF: 'CHF' };
export const getCurrencySymbol = (currency) =>
  CURRENCY_SYMBOLS[currency || sessionCurrency] || (currency || sessionCurrency);

// The locale AMOUNTS are formatted with follows the CURRENCY, not the UI
// language: USD must always render "$1,234.56" (never "1 234,56 $US" for a
// French admin). Dates keep following the user's language.
export const getCurrencyLocale = (currency) =>
  CURRENCY_LOCALES[currency || sessionCurrency] || 'fr-FR';

// Same as formatAmount but with cents (2 decimals) — for payments/services UI.
export const formatAmountPrecise = (amount, currency) => {
  const cur = currency || sessionCurrency;
  return new Intl.NumberFormat(CURRENCY_LOCALES[cur] || 'fr-FR', {
    style: 'currency',
    currency: cur,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount || 0);
};

export const formatAmount = (amount, locale = 'fr-FR', currency) => {
  const cur = currency || sessionCurrency;
  const formatLocale = CURRENCY_LOCALES[cur] || locale;
  return new Intl.NumberFormat(formatLocale, {
    style: 'currency',
    currency: cur,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(amount || 0);
};

export const formatDate = (date, locale = 'fr-FR', options = {}) => {
  const defaultOptions = { day: 'numeric', month: 'short' };
  return new Date(date).toLocaleDateString(locale, { ...defaultOptions, ...options });
};

export const formatMonth = (date, locale = 'fr-FR') => {
  return new Date(date).toLocaleDateString(locale, { month: 'long', year: 'numeric' });
};

// Owner Portal color tokens (iOS style)
export const ownerColors = {
  primary: '#007AFF',
  primaryLight: '#007AFF15',
  success: '#34C759',
  successLight: '#34C75915',
  warning: '#FF9500',
  warningLight: '#FF950015',
  error: '#FF3B30',
  bg: '#F2F2F7',
  card: '#FFFFFF',
  text: '#000000',
  textSecondary: '#8E8E93',
  textTertiary: '#C7C7CC',
  border: '#E5E5EA',
  borderLight: '#F2F2F7',
};
